import { QueryClient, useQuery } from "react-query";

import { cardProcessorService } from "../services/cardProcessorService";

export type ClientHorizonData = {
  rendas?: Array<{ valor?: number }>;
  extratoClienteResponse?: {
    devedorTotal?: number;
    valorFaturaFechada?: number;
    limite?: number;
    valorLimiteExtra?: number;
  };
  produto: {
    id?: number;
    descricao?: string;
    isProdutoBandeirado?: unknown;
    isProdutoDigital?: unknown;
  };
  transicaoBandeira?: unknown;
  produtoTransicaoBandeira?: unknown;
  faturaFutura?: unknown;
  enderecoResidencial?: unknown;
  enderecoComercial?: unknown;
  enderecoAlternativo?: unknown;
};

export const CLIENT_HORIZON_QUERY_KEY = (id?: number | string | null) =>
  ["clientId", id] as const;

const CLIENT_HORIZON_CACHE_OPTIONS = {
  staleTime: Infinity,
  retry: false as const,
};

export type FetchClientHorizonOptions = {
  force?: boolean;
};

export function fetchClientHorizon(
  queryClient: QueryClient,
  id: number | string,
  options?: FetchClientHorizonOptions
): Promise<ClientHorizonData> {
  return queryClient.fetchQuery(
    CLIENT_HORIZON_QUERY_KEY(id),
    () => cardProcessorService.getClientId(id, options?.force), 
    options?.force ? { staleTime: 0, retry: false } : CLIENT_HORIZON_CACHE_OPTIONS
  );
}

type UseClientHorizonOptions<TSelected> = {
  enabled?: boolean;
  select?: (data: ClientHorizonData) => TSelected;
};

export function useClientHorizon<TSelected = ClientHorizonData>(
  id?: number | string | null,
  options?: UseClientHorizonOptions<TSelected>
) {
  return useQuery(
    CLIENT_HORIZON_QUERY_KEY(id),
    () => cardProcessorService.getClientId(id),
    {
      enabled: id != null && id !== "" && (options?.enabled ?? true),
      ...CLIENT_HORIZON_CACHE_OPTIONS,
      select: options?.select,
    }
  );
}
